export interface SettingsStoreActionType {
  type: '@settings/STORE';
  payload: any;
}

export const storeSettings = (data: any): SettingsStoreActionType => ({
  type: '@settings/STORE',
  payload: data,
});
